// Hand-rolled hash router (~40 lines). Project policy: prefer hand-rolling
// over adding dependencies (08-money-standard.md §6). Routes are flat hash
// paths: #/dashboard, #/karyawan, ... — no params needed yet; add a tiny
// matcher when the slip detail page needs #/slip/:id.
import { createSignal } from 'solid-js';

function currentPath() {
  const h = window.location.hash;
  return h.startsWith('#/') ? h.slice(1) : '/dashboard';
}

const [path, setPath] = createSignal(currentPath());

window.addEventListener('hashchange', () => setPath(currentPath()));

/** Reactive accessor for the current route path, e.g. "/dashboard". */
export const route = path;

/** Navigate programmatically. */
export function navigate(to) {
  window.location.hash = '#' + to;
}
